import React, { useState , useEffect , useRef } from 'react';

const CredenceResponsible = () => {


    const [showButton, setShowButton] = useState(false);
    const clickTimeoutRef = useRef(null);

    // Show/hide button on scroll
    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 500);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

      // Click handler
      const handleClick = () => {
        if (clickTimeoutRef.current) {
            // Double click detected
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            // Wait to see if it's a double click
            clickTimeoutRef.current = setTimeout(() => {
                const target = document.querySelector('.other-privacy-content');
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
                clickTimeoutRef.current = null;
            }, 300);
        }
    };


  return (
    <>
    <main className="container-fluid p-0">  
        <section className="legal-container">
            <div className="legal-wrapper">
                <div className="legal-content-section">
                    <h1 className="card-title-xl fw-l text-balance">Responsible Reporting Policy</h1>
                </div>
                <div className="legal-image-container">
                    <img src="/assets/images/vulnerability.webp" alt="" style={{aspectRatio:"18/8"}}/>
                </div>
            </div>
        </section>
        
        <section className="privacy-section mb-3" id="">
            <div className="rvd-wrapper mb-4">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <p className="xxsmall fw-sb mb-3 text-uppercase ">Credence Resource Management</p>
                            <h2 className="card-title-md mb-4 ">Responsible Vulnerability Disclosure</h2>
                            <p className="xsmall mb-3 text-balance ">Credence Resource Management is committed to protecting the security of its systems and information. If you
                                become aware of a suspected security vulnerability affecting any Credence public-facing website or
                                information resource, please report it to <a href="mailto:security@credencerm.com" aria-label="Send email to security"><u>security@credencerm.com</u></a>
                            </p>
                            <p className="xsmall mb-3 text-balance ">This disclosure channel is provided solely for reporting potential vulnerabilities. <b>It does
                                    not authorize
                                    any third party to conduct scanning, probing, penetration testing, exploitation, denial-of-service
                                    testing, or any other activity that may access data or degrade, disrupt, or interfere with Credence
                                    systems. Such activities are strictly prohibited unless expressly authorized by Credence in writing in
                                    advance.</b>
                            </p>
                            <p className="xsmall mb-3 text-balance ">Reports should be submitted responsibly and must not include confidential, personal, client, or
                                other
                                non-public data. Credence reserves all legal rights and remedies with respect to any unauthorized activity.
                            </p>
                            <div className="report-box" aria-label="Reporting channel">
                                <strong>Report suspected vulnerabilities:</strong>
                                <a href="mailto:security@credencerm.com" aria-label="Send email to security"><u>security@credencerm.com</u></a>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>

            <div className="other-privacy-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="note-card" role="note" aria-label="Important restriction">
                            <h2 className="paragraph-xs text-balance">Important Restriction</h2>
                            <p className="xsmall mb-0">Submission of a report does not authorize any person to scan, probe, test, exploit, disrupt, or access Credence
                            systems.</p>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="card " id=" ">
                            <h2 className="card-title-sm text-balance">Responsible Vulnerability Disclosure Program</h2>
                            <p className="xsmall mb-0">
                                This policy provides a controlled process for receiving and internally reviewing suspected vulnerability reports without authorizing third-party security testing.
                            </p>
                        </div>
                        <div className="card">
                            <h2 className="paragraph-xs"> Purpose </h2>
                            <p className="xsmall mb-1">Credence Resource Management (“Credence”) is committed to maintaining the security of its
                                information systems and
                                protecting the data of its clients, employees, and other stakeholders. This Responsible Vulnerability Disclosure
                                Program provides a formal channel through which individuals may report suspected security vulnerabilities
                                identified
                                in relation to Credence’s public-facing websites and information resources.</p>
                            <p className="xsmall mb-0">
                                <b>This program is intended solely to facilitate the responsible reporting and internal review of
                                    potential security concerns. It is not a bug bounty program, penetration testing authorization, or
                                    invitation to conduct security
                                    testing against Credence systems.
                                </b>
                            </p>
                        </div>
                        
                        
                        <div className="card">
                            <h2 className="paragraph-xs"> Reporting a Potential Vulnerability</h2>
                            <p className="xsmall mb-1 text-balance">Any individual who becomes aware of a suspected security vulnerability affecting Credence’s public-facing websites or
                                information resources may report it to <a href="mailto:security@credencerm.com">security@credencerm.com</a>.</p>
                            <p className="xsmall mb-1">Reports should include, where available:</p>
                            
                            <ul className="xsmall ps-4 mb-2">
                                <li>A clear description of the suspected issue</li>
                                <li>The affected website, URL, or information resource</li>
                                <li>The date and time the issue was observed</li>
                                <li>Steps to reproduce the issue, if known</li>
                                <li className="text-balance">Screenshots or supporting evidence, provided only where doing so does not involve accessing, collecting, copying, or
                                    exposing confidential, personal, client, or other non-public data</li>
                            </ul>
                            <p className="xsmall mb-1">Credence may request additional information where reasonably necessary to validate and investigate a report.</p>
                        </div>

                        <div className="card">
                            <h2 className="paragraph-xs"> Prohibited Activities and No Authorization to Test</h2>
                            <p className="xsmall mb-1 text-balance"> <b>This program does not authorize any person or organization to conduct testing, scanning, probing, exploitation, or any other activity against Credence systems. </b> </p>
                            <p className="xsmall mb-1">Unless Credence has provided prior express written authorization, third parties are strictly prohibited from engaging in any of the following activities:</p>
                            
                            <ul className="xsmall ps-4 mb-2">
                                <li className="text-balance">Automated vulnerability scanning, port scanning, crawling, enumeration, fuzzing, or similar testing</li>
                                <li className="text-balance">Manual or automated penetration testing</li>
                                <li className="text-balance">Attempting to bypass authentication, authorization, or access controls</li>
                                <li className="text-balance">Exploiting or attempting to exploit any suspected vulnerability</li>
                                <li className="text-balance">Accessing, modifying, deleting, downloading, copying, transmitting, or exposing any data</li>
                                <li className="text-balance">Testing that may impair, degrade, interrupt, or disrupt the availability, performance, integrity, or operation of
                                     any Credence system</li>
                                <li className="text-balance">Denial-of-service or distributed denial-of-service testing</li>
                                <li className="text-balance">Social engineering, phishing, vishing, smishing, or physical security testing</li>
                                <li className="text-balance">Testing of any system, application, endpoint, infrastructure, network, cloud environment, or service beyond ordinary
                                     use of Credence’s public-facing websites and information resources in the manner intended for general visitors</li>
                                <li className="text-balance">Any activity involving systems or data belonging to Credence clients, employees, vendors, or other third parties</li>
                                <li className="text-balance">Any activity that violates applicable law, contractual obligations, or the rights of any person or entity</li>
                            </ul>
                            <p className="xsmall mb-1 text-balance"> <b> The existence of this program, the publication of this policy, or the submission of a report to Credence shall not be interpreted as consent, permission, authorization, license, waiver, or approval for any person to access, scan, test, probe, or otherwise interact with Credence systems beyond ordinary use of its public-facing websites and information resources in the manner intended for general visitors. </b></p>
                        </div>

                        <div className="card">
                            <h2 className="paragraph-xs"> Responsible Reporting Expectations</h2>
                            <p className="xsmall mb-1">Individuals submitting reports are expected to:</p>
                            
                            <ul className="xsmall ps-4 mb-2">
                                <li className="text-balance">Act lawfully and in good faith</li>
                                <li className="text-balance">Submit reports only through the designated reporting channel</li>
                                <li className="text-balance">Avoid any activity that could harm Credence, its systems, its clients, or any other party</li>
                                <li className="text-balance">Refrain from publicly disclosing the suspected issue, associated details, or related communications unless and until
                                    Credence has provided written approval</li>
                                <li className="text-balance">Preserve the confidentiality of all information obtained or observed in connection with a report</li>
                                <li className="text-balance"><b>Stop all activity immediately if they encounter or inadvertently access any non-public information, personal
                                        information, confidential information, or client data, and promptly notify Credence</b></li>
                            </ul>
                        </div>




                        <div className="card">
                            <h2 className="paragraph-xs"> Credence Review and Response</h2>
                            <p className="xsmall mb-1">Upon receipt of a report, Credence may:</p>
                            
                            <ul className="xsmall ps-4 mb-2">
                                <li>Acknowledge receipt of the report</li>
                                <li>Review the information provided</li>
                                <li>Determine whether the report is credible and requires further review</li>
                                <li>Conduct internal validation and remediation activities, where appropriate</li>
                                <li>Communicate with the reporter, at Credence’s discretion, regarding the status or outcome of the review</li>
                            </ul>
                            <p className="xsmall mb-1">Credence reserves the right to determine, in its sole discretion, whether a reported matter constitutes a valid vulnerability, the level of severity, the appropriate remediation action, and whether any further communication is warranted.</p>
                        </div>


                        <div className="card">
                            <h2 className="paragraph-xs"> Public Disclosure</h2>
                            <p className="xsmall mb-1 text-balance"><b>No individual may publicly disclose, publish, share, or otherwise communicate information about a suspected or confirmed vulnerability affecting Credence systems without Credence’s prior written authorization.</b></p>
                            <p className="xsmall mb-1">This includes, without limitation:</p>
                            
                            <ul className="xsmall ps-4 mb-2">
                                <li>Technical details</li>
                                <li>Proof-of-concept information</li>
                                <li>Screenshots</li>
                                <li>Exploit methods</li>
                                <li>Correspondence with Credence</li>
                                <li>Information about remediation status or timelines</li>
                            </ul>
                            <p className="xsmall mb-1">Credence may, at its discretion, coordinate disclosure where it determines that doing so is appropriate.</p>
                        </div>


                        <div className="card">
                            <h2 className="paragraph-xs"> No Compensation or Recognition Obligation</h2>
                            <p className="xsmall mb-1"><b>This program is not a bug bounty program. Submission of a report does not create any entitlement to:</b></p>
                            
                            <ul className="xsmall ps-4 mb-2">
                                <li>Monetary compensation</li>
                                <li>Reward</li>
                                <li>Reimbursement</li>
                                <li>Public acknowledgment</li>
                                <li>Employment, contract, or business opportunity</li>
                                <li>Any other form of consideration</li>
                            </ul>
                            <p className="xsmall">Credence may, at its sole discretion, acknowledge a reporter’s contribution, but has no obligation to do so.</p>
                        </div>

                        <div className="card">
                            <h2 className="paragraph-xs">Legal Rights Reserved</h2>
                            <p className="xsmall mb-1">Credence reserves all legal rights and remedies available under applicable law, contract, and policy.</p>
                            <p className="xsmall mb-1">Nothing in this program:</p>
                            <ul className="xsmall ps-4 mb-2">
                                <li>Grants any license, permission, or authorization to access, scan, test, probe, or interact with Credence systems</li>
                                <li>Waives any rights of Credence</li>
                                <li>Limits Credence’s ability to investigate, restrict, block, or take legal action in response to unauthorized activity</li>
                                <li>Creates any contractual obligation, partnership, agency, fiduciary duty, or other legal relationship between Credence and any reporter</li>
                                <li>Requires Credence to accept, investigate, remediate, or respond to any report in a particular manner or timeframe</li>
                            </ul>
                            <p className="xsmall mb-0 text-balance">Any activity outside the limited reporting process described in this policy may be treated as unauthorized and may be referred for appropriate legal, contractual, or law-enforcement action.</p>
                        </div>

                        <div className="card">
                            <h2 className="paragraph-xs">Policy Changes</h2>
                            <p className="xsmall mb-1">Credence may modify, suspend, or withdraw this Responsible Vulnerability Disclosure Program
                                at any time, without prior notice. The version published by Credence at the time of submission will govern the
                                handling of the report.</p>
                        </div>


                        <div className="card">
                            <p className="xxsmall mb-1 text-center">© Credence Resource Management. This page is intended as a public-facing responsible vulnerability disclosure statement and policy.</p>
                        </div>

                    </div>
                </div>
                
             </div>        
        </section>
    </main>

    <button
            id="scrollToTopBtn"
            className="scrollTopButton"
            aria-label="Scroll to top"
            style={{ display: showButton ? 'block' : 'none' }}
            onClick={handleClick}
        >
            <i className="bx bx-chevron-up"></i>
        </button>
    </>
  );
};

export default CredenceResponsible;
